import { render, staticRenderFns } from "./GiftRecipient.vue?vue&type=template&id=7b8bd7ec&scoped=true"
import script from "./GiftRecipient.vue?vue&type=script&lang=js"
export * from "./GiftRecipient.vue?vue&type=script&lang=js"
import style0 from "./GiftRecipient.vue?vue&type=style&index=0&id=7b8bd7ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8bd7ec",
  null
  
)

export default component.exports